import styled from 'styled-components'

const Container = styled.section`
  padding: 0 20px;
  max-width: 960px;
  margin: 0 auto;
`

export default Container
